import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false
  },
  getters: {
    authenticated(state) {
      return state.isLoggedIn === true
    }
  },
  mutations: {
    setAuth(state) { state.isLoggedIn = true },
    unsetAuth(state) { state.isLoggedIn = false },
  },
  actions: {
  },
  modules: {
  }
})
